/**
 * Отмена работы человеком — не ошибка, и путать их нельзя.
 *
 * 🔴 Опрос статуса живёт в цикле, который сам по себе не кончается: пока
 * задача не готова, он идёт. Нажатие «Отменить» обрывает его исключением, и
 * без отдельного типа экран показал бы поверх пустого поля красную полосу
 * «Не удалось обработать запись» — человеку сообщили бы о сбое там, где он сам
 * попросил остановиться.
 */

export class CancelledError extends Error {
  constructor() {
    super('Отменено');
    this.name = 'CancelledError';
  }
}

export const isCancelled = (error) => error?.name === 'CancelledError';
